import { render, staticRenderFns } from "./RankedEmissionsByActivity.vue?vue&type=template&id=46131d1c"
import script from "./RankedEmissionsByActivity.vue?vue&type=script&lang=js"
export * from "./RankedEmissionsByActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports